/**
 * Platform detection helpers.
 *
 * Used to gate "Coming Soon" / preview features on iOS App Store builds so
 * Apple reviewers only see complete features (Apple Guideline 4.0 — Design).
 * On the web (and Android once shipped), those preview tiles remain visible.
 */

export function isIOSNative() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  try {
    return !!(cap?.isNativePlatform?.() && cap?.getPlatform?.() === "ios");
  } catch {
    return false;
  }
}

export function isAndroidNative() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  try {
    return !!(cap?.isNativePlatform?.() && cap?.getPlatform?.() === "android");
  } catch {
    return false;
  }
}

export function isNative() {
  return isIOSNative() || isAndroidNative();
}

/**
 * True when the user CAN see paid features inline (web + Android).
 * False on iOS — we hide upgrade CTAs, wallet top-ups, paid expert
 * evaluations, etc., to comply with Apple Guideline 3.1.1 (In-App Purchase).
 *
 * To force this on/off during QA or for Apple Review, set
 *   localStorage.thqah_force_ios = "1"
 * in the browser DevTools.
 */
export function canShowPaidFeatures() {
  if (typeof window !== "undefined") {
    try {
      if (window.localStorage.getItem("thqah_force_ios") === "1") return false;
    } catch {/* ignore */}
  }
  return !isIOSNative();
}
